import React, {Component} from 'react';
import {Row, Col} from 'react-bootstrap';

export default class ManageNGO extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
		};
	}

	render() {
		return (
			<Row>
				ManageNGO
			</Row>
		);
	}
}